export default __webpack_public_path__ + "static/media/logo_alt-light-bg.7ef4888b.svg";